import { useInfiniteQuery, useQuery } from '@tanstack/react-query'
import { getOnlineProfile, getListPropertyOnlineProfile } from "./api"

export const useGetOnlineProfile = ({ id, options = {} }) => {
  return useQuery({
    queryKey: ['get-online-profile', id],
    queryFn: () => getOnlineProfile(id),
    ...options
  })
}

export const useGetListPropertiesOnlineProfile = ({ id, params, options = {} }) => {
  return useInfiniteQuery({
    queryKey: ['get-list-properties-online-profile', id, params],
    queryFn: ({ pageParam = 1 }) => getListPropertyOnlineProfile(id, { ...params, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      return !!lastPage?.data?.data?.length ? allPages.length + 1 : undefined;
    },
    ...options
  })
}